import React, {useState} from 'react';
import {Rate, Spin} from 'antd';
import ConnectIcon from '../../../imgs/connection.svg';
import successIcon from '../../../imgs/successfulicon.svg';
import {gql, useMutation} from '@apollo/client';
import {COMPELTE_OFFER} from '../../../graphql/mutations/offers';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const MarkCompleteModal = ({
  firstName,
  lastName,
  fullName,
  offerId,
  handleCancel,
  bountyType,
  company
}) => {
  const history = useHistory();
  const [rating, setRating] = useState(0);
  const [loader, setLoader] = useState(false);
  const strapiRes = useSelector(state => state.strapiRes);

  const handleRate = (value) => {
    setRating(value);
  };

  const [completeOffer] = useMutation(gql(COMPELTE_OFFER));

  const handleMarkComplete = () => {
    if (offerId && rating) {
      setLoader(true);
      completeOffer({
        variables: {
          offerId: offerId,
          rating: parseFloat(rating),
        },
      }).then((res) => {
        setLoader(false);
        history.push(`/${strapiRes.userName}`)
        handleCancel();
      });
    }
  };

  return (
    <Spin spinning={loader}>
      <div className="bounty-modal-wrapper submit-wrapper">
        <div className="center-content">
          <img src={successIcon} alt="successIcon" className="icon" />
          <h2 className="heading">
            @{firstName}
            {lastName} <img src={ConnectIcon} alt="ConnectIcon" /> {bountyType === 'company' ? company : fullName}
          </h2>
          <p>Bounty will be released.</p>
          <div className="rate-box">
            <h3 className="small-heading">
              Rate {firstName}
              {lastName}
            </h3>
            <Rate
              style={{ color: "#000" }}
              value={rating}
              onChange={(val) => handleRate(val)}
            />
          </div>
        </div>
        <div className="row m-0 w-100">
          <div className="col-6 pl-0">
            <button className="btn-style cancel " onClick={handleCancel}>
              Cancel
            </button>
          </div>
          <div className="col-6 pr-0">
            <button className="btn-style" onClick={handleMarkComplete}>
              Mark as completed
            </button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default MarkCompleteModal;
